export class AwsDynamoDbSnapshotPropertiesGlobalSecondaryIndexesInnerProjection {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "projectionType",
            "baseName": "projectionType",
            "type": "string",
            "format": ""
        },
        {
            "name": "nonKeyAttributes",
            "baseName": "nonKeyAttributes",
            "type": "Array<string>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return AwsDynamoDbSnapshotPropertiesGlobalSecondaryIndexesInnerProjection.attributeTypeMap;
    }
    constructor() {
    }
}
